module.exports = __webpack_public_path__ + "ath_game_web/img/7.6.1.bb742460.png";